import { updateKorDeparture } from '@/api';
import Step1 from '@/components/MedicalDepartureWifi/Step1';
import { useAppSelector } from '@/hooks/useReduxHooks';
import useWifiErrorModal from '@/hooks/useWifiErrorModal';
import useWifiResolveModal from '@/hooks/useWifiResolveModal';
import { IGlobalState } from '@/store';
import { getOS } from '@/utils/checkOS.util';
import { format } from 'date-fns';
import React from 'react';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

type Props = {
  isAndroid?: boolean;
  place?: 'airport' | 'port';
};

function MedicalKorDepartureStep1({
  isAndroid = false,
  place = 'airport',
}: Props) {
  const history = useHistory();
  const { passportNumber, departureDate } = useAppSelector(
    (state) => state,
  ) as IGlobalState;

  const { mutate: mutateUpdateKorDeparture } = useMutation(updateKorDeparture);

  const { onOpenModal: onOpenResolveModal, Modal: ResolveModal } =
    useWifiResolveModal({ place });
  const { onOpenModal: onOpenErrorModal, Modal: ErrorModal } =
    useWifiErrorModal({ isAndroid, onOpenResolveModal, place });

  const handleCheckWifi = () => {
    mutateUpdateKorDeparture(
      {
        passportNumber: passportNumber!,
        departureDate: departureDate
          ? format(new Date(departureDate), 'yyyy-MM-dd')
          : null,
        isDeparted: true,
        device: getOS(navigator.userAgent),
      },
      {
        onSuccess: handleMoveToStep2,
        onError: onOpenErrorModal,
      },
    );
  };

  const handleMoveToStep2 = () => {
    const currentUrl = new URL(window.location.href);
    history.push(`${currentUrl.pathname}?step=2`);
  };

  return (
    <>
      <Step1 isAndroid={isAndroid} place={place} isDetailStep />
      <ButtonWrapper>
        <Button onClick={handleCheckWifi}>와이파이 인증</Button>
        {isAndroid || (
          <ResolveButton onClick={onOpenResolveModal}>
            네트워크 오류 해결방법
          </ResolveButton>
        )}
      </ButtonWrapper>
      {ResolveModal}
      {ErrorModal}
    </>
  );
}

const Button = styled.button`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #246cf6;
  border-radius: 8px;
  padding: 14px 28px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  box-shadow: 0px 4px 12px 0px #1919192e;
  margin-top: 48px;
`;

const ResolveButton = styled.button`
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
  color: #80848a;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export default MedicalKorDepartureStep1;
